import { useEffect, useState } from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { domainsListTableHeader } from "screens/Settings/Domains/DomainsHelpers";
import viewIcon from "assets/images/view.svg";
import strings from "global/constants/StringConstants";
import CustomTable from "global/components/CustomTable/CustomTable";
import CenteredCardLayout from "layouts/CenteredTableView/CenteredCardLayout";

interface CustomProps {
  domains: any[];
  domainViewButtonHandler: Function;
  isLoading: boolean;
}

const DomainList = (props: CustomProps) => {
  const [formattedDomainsRows, setFormattedDomainsRows] = useState<any[]>([]);

  useEffect(() => {
    getFormattedTableRow(props.domains);
  }, [props.domains]);

  const getEmailDomainStatus = (status: string) => {
    if (status === strings.EmailDomainStatus.Active) {
      return strings.EmailDomainStatusDisplayValue.Active;
    } else if (status === strings.EmailDomainStatus.CNAMEPending) {
      return strings.EmailDomainStatusDisplayValue.CNAMEPending;
    } else {
      return strings.EmailDomainStatusDisplayValue.VerificationPending;
    }
  };

  const getColors = {
    Active: "#47AA12",
    CNAMEPending: "#FF9436 ",
    VerificationPending: "#FF9436",
  } as { [key: string]: string };

  const getFormattedTableRow = (domains: any[]) => {
    const formattedRows = domains.map((domainItem: any) => {
      return {
        name: (
          <Stack direction="column">
            <Link
              color="text.primary"
              variant="subtitle2"
              onClick={() => {
                props.domainViewButtonHandler(
                  domainItem.name,
                  domainItem.status
                );
              }}
              component={"div"}
              sx={{ cursor: "pointer" }}
            >
              {domainItem.name}
            </Link>
          </Stack>
        ),
        status: (
          <Typography
            sx={{
              color: getColors[domainItem.status],
              display: "flex",
              alignItems: "center",
            }}
            variant="subtitle2"
          >
            <Box
              sx={{
                // ...classes.contactStatusBox,
                backgroundColor: getColors[domainItem.status],
              }}
            />
            {getEmailDomainStatus(domainItem.status)}
          </Typography>
        ),
        action: (
          <Box
            onClick={() => {
              props.domainViewButtonHandler(domainItem.name, domainItem.status);
            }}
            sx={{ cursor: "pointer" }}
          >
            <Box component={"img"} src={viewIcon} /> <span>View</span>
          </Box>
        ),
      };
    });
    setFormattedDomainsRows(formattedRows);
  };

  const getDomainsList = () => {
    return (
      <CenteredCardLayout removeLastChildBottomPadding={true}>
        <Box>
          <CustomTable
            headers={domainsListTableHeader}
            rows={formattedDomainsRows}
            isLoading={props.isLoading}
            showPagination={false}
          />
        </Box>
      </CenteredCardLayout>
    );
  };

  return getDomainsList();
};

export default DomainList;
